export default __webpack_public_path__ + "static/media/Microfinance-Banking.8694fb52.jpg";